module.exports = function(angular, app) {
  var format = require('../../format')
    , numberFormat = format.numberFormat
    , durationFormat = format.durationFormat
    , createDurationFormatFn = format.createDurationFormatFn
    , createNumberFormatFn = format.createNumberFormatFn

  var TIME_UNITS = {
    'ms': 1,
    's': 1000,
    'm': 60*1000,
    'h': 60*60*1000,
    'd': 24*60*60*1000,
    'W': 7*24*60*60*1000,
    'M': (365/12)*24*60*60*1000
  };

  function deepMetricFormatService(value, format, defaultFormat) {
    var args = parseFormat(format, defaultFormat)
      , unit = args.unit;
    if (args.type === 'duration') {
      value = durationFormat(value, args.format, args.multiplier);
    }
    else {
      value = numberFormat(value, args.format);
    }
    if (unit) {
      value = args.unitAsPrefix ? unit + ' ' + value
                                : value + ' ' + unit;
    }
    return value;
  }

  deepMetricFormatService.TIME_UNITS = Object.keys(TIME_UNITS);
  deepMetricFormatService.NUMBER_FORMATS = format.NUMBER_FORMATS;
  deepMetricFormatService.DURATION_FORMATS = format.DURATION_FORMATS;
  deepMetricFormatService.numberFormat = numberFormat;
  deepMetricFormatService.durationFormat = durationFormat;
  deepMetricFormatService.templateToPrecision = format.precisionPartFromFormat;
  deepMetricFormatService.templateToDenomination = format.prefixPartFromFormat;

  deepMetricFormatService.createFormatFn = function(format, defaultFormat) {
    var args = parseFormat(format, defaultFormat);
    if (args.type === 'duration') {
      return createDurationFormatFn(args.format, args.multiplier, args.unit, args.unitAsPrefix);
    }
    else {
      return createNumberFormatFn(args.format, args.unit, args.unitAsPrefix);
    }
  };
/*
  {
    format: {
      type: 'numeric',
      template: '0.00',
      unit: 'USD',
      unitAsPrefix: false
    },
*/
  function parseFormat(format, defaultFormat) {
    var type, template, timeunit, unit, unitAsPrefix;

    if (defaultFormat && 'object' === typeof defaultFormat) {
      type = defaultFormat.type;
      template = defaultFormat.template;
      timeunit = defaultFormat.timeunit;
      unit = defaultFormat.unit;
      unitAsPrefix = !!defaultFormat.unitAsPrefix;
    }

    if (format && 'object' === typeof format) {
      if (format.type !== undefined) type = format.type;
      if (format.template !== undefined) template = format.template;
      if (format.timeunit !== undefined) timeunit = format.timeunit;
      if (format.unit !== undefined) unit = format.unit;
      if (format.unitAsPrefix !== undefined) unitAsPrefix = !!format.unitAsPrefix;
    }

    return {type: type, format: template, multiplier: timeUnitToMultiplier(timeunit)
           , unit: unit, unitAsPrefix: unitAsPrefix};
  }

  function timeUnitToMultiplier(timeunit) {
    if (timeunit == null) return 1;
    return TIME_UNITS[timeunit] || timeunit;
  }


  function deepMetricFormatFilter(value, type, template, timeunit) {
    if (type === 'duration') {
      return durationFormat(value, template, timeUnitToMultiplier(timeunit));
    }
    else {
      return numberFormat(value, template);
    }
  }

  app.factory('deepMetricFormat', function() { return deepMetricFormatService; });
  app.filter('deepMetricFormat', function() { return deepMetricFormatFilter; });
};

/*

"deepMetricFormat" as a filter:

{{ value | deepMetricFormat:type:template:timeunit}}
{{ value | deepMetricFormat:'number':'0.00'}}
{{ value | deepMetricFormat:'duration':'hh:mm':'s'}}

"deepMetricFormat" as a service:

deepMetricFormat(value[, format[, defaultFormat]]) -> string
deepMetricFormat.createFormatFn(format, defaultFormat]) -> function(value) -> string

e.g.:

query.meta.metrics = [
  // metryka 1
  {
    format: {
      type: 'numeric',
      template: '0.00',
      unit: 'USD',
      unitAsPrefix: false
    },
    visual: {
      grid: {
        format: {
          type: 'numeric',
          template: 'All digits'
        }
      }
    }
  },
  // metryka 2
  {format: {
      type: 'duration',
      template: 'hh:mm',
      timeunit: 'ms'
    }
  },
]

var formatFn = deepMetricFormat.createFormatFn(query.meta.metrics[0].visual.grid.format, query.meta.metrics[0].format);
formatFn(1234567890.1234567890);

// other helper static properties:

// suitable for format.template when format.type is "number"
deepMetricFormat.NUMBER_FORMATS -> Array of strings

// suitable for format.template when format.type is "duration"
deepMetricFormat.DURATION_FORMATS -> Array of strings

// suitable for format.timeunit
deepMetricFormat.TIME_UNITS -> Array of strings

*/